module.exports = {"private":true,"main":"./MultiImageUpload.js"}


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/fields/MultiImageUpload/package.json
// module id = 835
// module chunks = 0 1